/* ══════════════════════════════════════════════════════════════════════
   assets/uc-search-intel.js
   URBAN Care — arama zekası katmanı (istemci tarafı)

   Sorgu Shopify'a gitmeden ÖNCE araya girer:
     1. Türkçe normalizasyon  (yalnızca EŞLEŞTİRME için)
     2. Eş anlamlı çeviri     ("olaplex" → "bond plex")
     3. Yazım düzeltme        ("sanpuan" → "şampuan")
     4. Niyet yönlendirme     ("köpük" → /collections/sac-kopugu)
     5. Alan kapsamı          options[fields] enjekte eder (body hariç)

   ⚠️ TEMEL KURAL — TÜRKÇE KARAKTER KORUNUR
   Normalizasyon SADECE sözlükte arama yapmak için kullanılır.
   Shopify'a gönderilen sorgu her zaman doğru Türkçe karakterlerle olur:
     • sözlükte karşılığı varsa → sözlükteki düzgün Türkçe biçim
     • karşılığı yoksa         → kullanıcının yazdığı ORİJİNAL kelime
   Böylece "sülfatsız" gibi sözlükte olmayan kelimeler "sulfatsiz"e
   dönüşüp eşleşmeyi kaçırmaz.

   Sözlük snippets/uc-search-config.liquid içinde. Bu dosyaya dokunma.

   NOT: Bu katman sorguyu düzeltir. Sonuçların ALAKASINI ise sunucu
   tarafındaki snippets/uc-search-match.liquid süzer (etiket gürültüsü).
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.UC_SEARCH;
  if (!CFG) return;

  /* ── Türkçe normalizasyon ────────────────────────────────────────
     JS'te 'İ'.toLowerCase() → 'i̇' (i + birleşik nokta, 2 karakter).
     Bu tüm eşleşmeleri sessizce bozar. Bu yüzden harf çevirimi
     toLowerCase'DEN ÖNCE yapılır. */
  var TR_MAP = {
    'İ': 'i', 'I': 'i', 'ı': 'i',
    'Ş': 's', 'ş': 's',
    'Ğ': 'g', 'ğ': 'g',
    'Ü': 'u', 'ü': 'u',
    'Ö': 'o', 'ö': 'o',
    'Ç': 'c', 'ç': 'c',
    'Â': 'a', 'â': 'a',
    'Î': 'i', 'î': 'i',
    'Û': 'u', 'û': 'u'
  };

  function normalize(s) {
    if (!s) return '';
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var ch = s[i];
      out += (TR_MAP[ch] !== undefined) ? TR_MAP[ch] : ch;
    }
    return out
      .toLowerCase()
      .replace(/[^\w\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Kullanıcının yazdığını bozmadan sadece boşlukları toparla */
  function tidy(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  /* ── Damerau-Levenshtein (yer değiştirme dahil) ───────────────── */
  function editDistance(a, b) {
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (!al) return bl;
    if (!bl) return al;
    if (Math.abs(al - bl) > 2) return 99;

    var prev2 = [], prev = [], cur = [], i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;

    for (i = 1; i <= al; i++) {
      cur = [i];
      for (j = 1; j <= bl; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          cur[j] = Math.min(cur[j], prev2[j - 2] + 1);
        }
      }
      prev2 = prev; prev = cur;
    }
    return prev[bl];
  }

  function tolerance(len) {
    if (len <= 3) return 0;   // "yağ", "set" — düzeltme riskli
    if (len <= 5) return 1;
    return 2;
  }

  /* lexicon artık { normalize: 'düzgün Türkçe' } biçiminde */
  var LEX_KEYS = Object.keys(CFG.lexicon || {}).filter(function (k) {
    return k.indexOf(' ') === -1;
  });

  /* Bir kelimeyi sözlüğe göre düzelt.
     Dönüş: düzgün Türkçe biçim, ya da düzeltilemiyorsa null. */
  function correctToken(token) {
    if (token.length < 4) return null;
    if (CFG.lexicon[token]) return CFG.lexicon[token];

    var best = null, bestD = 99, tol = tolerance(token.length);
    for (var i = 0; i < LEX_KEYS.length; i++) {
      var d = editDistance(token, LEX_KEYS[i]);
      if (d < bestD) { bestD = d; best = LEX_KEYS[i]; }
    }
    return (best && bestD <= tol) ? CFG.lexicon[best] : null;
  }

  /* ── Ana yeniden yazma ─────────────────────────────────────────
     Dönüş: { q, intent, corrected, original } */
  function rewrite(raw) {
    var original = tidy(raw);
    var norm = normalize(original);

    if (!norm) {
      return { q: original, intent: null, corrected: false, original: original };
    }

    var SYN = CFG.synonyms || {};
    var INT = CFG.intents || {};

    /* 1) Tam ifade niyet eşleşmesi — en yüksek öncelik */
    if (INT[norm]) {
      return { q: original, intent: INT[norm], corrected: false, original: original };
    }

    /* 2) Tam ifade eş anlam eşleşmesi (çok kelimeli: "sac dokulmesi") */
    if (SYN[norm]) {
      return {
        q: SYN[norm],
        intent: INT[normalize(SYN[norm])] || null,
        corrected: normalize(SYN[norm]) !== norm,
        original: original
      };
    }

    /* 3) Token bazlı işleme.
       ÖNEMLİ: origTokens kullanıcının Türkçe karakterlerini taşır,
       normTokens yalnızca sözlük araması için kullanılır. */
    var origTokens = original.split(' ');
    var normTokens = norm.split(' ');

    /* Noktalama normalizasyonu token sayısını değiştirebilir —
       eşleşmiyorsa güvenli tarafta kal ve normalize edilmişi kullan. */
    if (origTokens.length !== normTokens.length) {
      origTokens = normTokens.slice();
    }

    var expanded = [];      // eş anlam + düzeltme uygulanmış
    var safe = [];          // yalnızca düzeltme uygulanmış (yedek)
    var didCorrect = false;

    for (var i = 0; i < normTokens.length; i++) {
      var nt = normTokens[i];
      var ot = origTokens[i];

      /* iki kelimelik ifadeyi önce dene: "dus" + "jeli" */
      if (i < normTokens.length - 1) {
        var pairNorm = nt + ' ' + normTokens[i + 1];
        var pairOrig = ot + ' ' + origTokens[i + 1];
        if (SYN[pairNorm]) {
          expanded.push(SYN[pairNorm]);
          safe.push(pairOrig);
          if (normalize(SYN[pairNorm]) !== pairNorm) didCorrect = true;
          i++;
          continue;
        }
      }

      /* Yazım düzeltme — düzgün Türkçe biçim döner ya da null */
      var fixed = correctToken(nt);
      var safeToken = fixed || ot;      // düzeltilemediyse ORİJİNALİ koru
      if (fixed && normalize(fixed) !== nt) didCorrect = true;
      safe.push(safeToken);

      /* Eş anlam — anahtar normalize biçim, değer düzgün Türkçe */
      var lookup = fixed ? normalize(fixed) : nt;
      if (SYN[lookup]) {
        if (normalize(SYN[lookup]) !== nt) didCorrect = true;
        expanded.push(SYN[lookup]);
      } else {
        expanded.push(safeToken);
      }
    }

    /* Tekrar eden kelimeleri temizle (aksansız karşılaştırıp
       görünen biçimi koru): "şampuan şampuan" → "şampuan" */
    function dedupe(parts) {
      var seen = {}, res = [];
      parts.join(' ').split(' ').forEach(function (w) {
        if (!w) return;
        var key = normalize(w);
        if (!key || seen[key]) return;
        seen[key] = 1;
        res.push(w);
      });
      return res;
    }

    var expandedWords = dedupe(expanded);
    var safeWords = dedupe(safe);

    /* ── AND KORUMASI ──────────────────────────────────────────────
       Shopify çoklu kelimede AND uygular — her kelime eşleşmek zorunda.
       Eş anlam genişletmesi sorguyu uzatırsa sonuç sayısı çöker.
       Örn: "biotin serum" → "biotin caffeine saç serumu" (4 kelime)
       Sınırı aşarsak eş anlamı bırak, yalnızca yazım düzeltmesini uygula. */
    var maxTokens = CFG.maxTokens || 3;
    var finalWords = (expandedWords.length > maxTokens && safeWords.length <= expandedWords.length)
      ? safeWords
      : expandedWords;

    var finalQ = finalWords.join(' ');

    return {
      q: finalQ,
      intent: (normTokens.length === 1 && INT[normalize(finalQ)]) ? INT[normalize(finalQ)] : null,
      corrected: didCorrect,
      original: original
    };
  }

  /* Dışarıya aç */
  window.UCSearch = { normalize: normalize, rewrite: rewrite, fields: CFG.fields };

  /* ── Form yakalama ───────────────────────────────────────────── */
  function ensureFieldsInput(form) {
    if (!CFG.fields) return;
    if (form.querySelector('input[name="options[fields]"]')) return;
    var el = document.createElement('input');
    el.type = 'hidden';
    el.name = 'options[fields]';
    el.value = CFG.fields;
    form.appendChild(el);
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/search') !== -1 && !!form.querySelector('input[name="q"]');
  }

  function wire(root) {
    (root || document).querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.dataset.ucWired === '1') return;
      if (!isSearchForm(form)) return;
      form.dataset.ucWired = '1';
      ensureFieldsInput(form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { wire(document); });
  wire(document);

  /* Header araması drawer içinde sonradan basılabiliyor */
  var mo = new MutationObserver(function () { wire(document); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ── Submit anında yeniden yazma ─────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isSearchForm(form)) return;

    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;

    var res = rewrite(input.value);

    /* Niyet eşleşmesi → doğrudan koleksiyona git */
    if (res.intent && CFG.redirectOnExactIntent) {
      e.preventDefault();
      window.location.href = '/collections/' + res.intent.handle;
      return;
    }

    ensureFieldsInput(form);

    if (res.q && res.q !== tidy(input.value)) {
      input.value = res.q;

      var orig = form.querySelector('input[name="uc_orig"]');
      if (!orig) {
        orig = document.createElement('input');
        orig.type = 'hidden';
        orig.name = 'uc_orig';
        form.appendChild(orig);
      }
      orig.value = res.original;
    }
  }, true);

  /* ── Predictive search entegrasyonu ──────────────────────────────
     Beautify'ın <predictive-search> bileşeni getResults(term) çağırıyor.
     Prototipi sarmalayıp terimi yeniden yazıyoruz — tema dosyasına
     dokunmuyoruz, böylece tema güncellemesinde yama kaybolmaz. */
  function patchPredictive() {
    var el = document.querySelector('predictive-search');
    if (!el) return false;
    var proto = Object.getPrototypeOf(el);
    if (!proto || typeof proto.getResults !== 'function') return false;
    if (proto.__ucPatched) return true;

    var original = proto.getResults;
    proto.getResults = function (term) {
      var res = rewrite(term);
      return original.call(this, res.q || term);
    };
    proto.__ucPatched = true;
    return true;
  }

  if (!patchPredictive()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (patchPredictive() || tries > 40) clearInterval(iv);
    }, 150);
  }
})();
